import React, { useState, useEffect, useCallback } from "react";
import {
  BiCheck,
  BiCopyright,
  BiEdit,
  BiHash,
  BiImage,
  BiPlus,
  BiRecycle,
  BiTrashAlt,
  BiXCircle,
  BiCheckCircle,
  BiChevronRight,
  BiChevronLeft,
  BiAlarm,
} from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";
import { TiChevronRight, TiChevronLeft } from "react-icons/ti";

import {
  BsArrowBarDown,
  BsEye,
  BsFillBookmarksFill,
  BsFillGearFill,
  BsStar,
  BsStarFill,
  BsDownload,
} from "react-icons/bs";
import { IoArrowBackCircle } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { v4 as uuidv4 } from "uuid";
import { HiChevronDoubleRight } from "react-icons/hi2";
import { HiChevronDoubleLeft } from "react-icons/hi2";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { ChromePicker } from "react-color";
import {
  Row,
  Col,
  Button,
  Popover,
  PopoverBody,
  ButtonGroup,
  Label,
  Dropdown,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import "../trivia-survey.css";
import SurveyQuestionsComponent from "./TriviaQuestionsComponent";
import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { snapToQuarterHour } from "../../../utils/dateUtils";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";
import { random, uniqueId } from "lodash";
import iphoneImage from "../../../assets/trivvy/iphoneimage.png";
import {
  contvertHTMLToPlain,
  formatQuestionsNumberWise,
  hexToRgb,
  profilePicValidityCheck,
  convertToRgba,
//  OVERTIME_TEXT,
  TRIVIA_EDIT_OVERTIME_TEXT,
  APPLICABLE_USER_FILE_LABEL,
  APPLICABLE_USER_FILE_TOOLTIP,
} from "../../../utils/constants";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import SurveyWelcomeComponent from "./TriviaWelcomeComponent";
import SurveyEndingComponent from "./TrviaEndingComponent";
import {
  applyCustomFontStyles,
  ASSIST_OPTIONS_MAP,
  DIFFICULTY_LEVELS,
  getDifficultyLevels,
  getNewQuestionEmptyObject,
  getSourceStringfromQuestion,
  getSourceStringfromResponse,
  getThemeSettingsForPage,
  getTriviaFileName,
  hashText,
  isAnswerChanged,
  isThemeSettingsAppliedToAllPages,
  isTrivvyGeneratedFromCustomTemplates,
  PUBLISH_SAVE_ERROR,
  renderCommentsCountTextFormat,
  TEMPLATE_TYPE_MAP,
  THEME_SETTING,
  trivvyFromCustomTemplates,
} from "../data";
import debounce from "lodash.debounce";
import { toastContainer } from "../../../utils/toast";
import parse from "react-html-parser";
import { deepClone } from "../../../utils/copyObject";
import { GiOpenTreasureChest } from "react-icons/gi";
import { MdOutlineQuiz } from "react-icons/md";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import Toggle from "react-toggle";
import If from "../../../components/Shared/If";
import { isMobile } from "../../../utils/deviceInfo";
import ReactTooltip from "react-tooltip";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import { MdOutlineAccessTime } from "react-icons/md";
import { PiCalendarPlus, PiWatchFill } from "react-icons/pi";
import TriviaRatingComponent from "./TriviaRatingComponent";
import {
  FaCaretDown,
  FaChevronLeft,
  FaChevronRight,
  FaRecycle,
  FaRegComment,
} from "react-icons/fa6";
import { diff } from "semver";
import ColorPickerWrapper from "../../../components/UI/WrapperColor/ColorPickerWrapper";
import TriviaCommentsComponent from "./TriviaCommentsComponent";
import { FaUndo } from "react-icons/fa";
import FontSelector from "../../../components/TrivvyFontConfigs/FontSelector";
import FontStyleSelector from "../../../components/TrivvyFontConfigs/FontStyleSelector";
import IPhoneWrapper from "../Quiz/IphoneWrapper/IphoneWrapper";

function TriviaEditViewListUI({
  setAdvanceSettingModal,
  questions,
  setCurrentTriviaQuestions,
  currentTrivia,
  editCurrentTriviaWelcomeData,
  editCurrentTriviaEndingData,
  editCurrentTriviaThemeData,
  user,
  showPopupModal,
  linkedRewards,
  setCurrentTrivia,
  planType,
  setCurrentTrivvyComments,
  currentTrivvyComments,
  publishTriviaApiCall,
  ...props
}) {
  const [showStyleTheme, setShowStyleTheme] = useState(false);
  const [hoveredQuestion, setHoveredQuestion] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState("WELCOME");
  const [view, setView] = useState("DESKTOP");
  const [questionPopoverOpen, setQuestionPopoverOpen] = useState(null);
  const [questionCreateLoading, setQuestionCreateLoading] = useState(false);
  const [customTextModal, setCustomTextModal] = useState(false);
  const [templateParamsModal, setTemplateParamsModal] = useState(null);
  const [allCommentsPopoverOpen, setAllCommentsPopoverOpen] = useState(false);
  const [showQuestionDG, setShowQuestionDG] = useState(false);
  const [metaDataS3Url, setMetaDataS3Url] = useState(null);
  const [uploadedAt, setUploadedAt] = useState(null);
  const [latestFileName, setLatestFileName] = useState(null);
  const [metaDataId, setMetaDataId] = useState(null);
  let isEditable = currentTrivia && !currentTrivia.isPublished;
  let adminRestricted = false;
  if (currentTrivia && currentTrivia.createdBy && user && user.profile) {
    if (currentTrivia && currentTrivia.createdBy._id != user.profile._id) {
      if (!currentTrivia.isPublished) {
        isEditable = false;
      }

      adminRestricted = true;
    }

    if (user.profile.orgAdmin || user.profile.role == "Admin") {
      if (!currentTrivia.isPublished) {
        isEditable = true;
      }
      adminRestricted = false;
    }
  }
  const questionEditable =
    currentTrivia &&
    currentTrivia.isPublished == false &&
    currentTrivia.totalSubmissions == 0
      ? true
      : false;
  const [showEndDateEdit, setShowEndDatEdit] = useState(false);
  const [showScheduledDateEdit, setShowScheduledDateEdit] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(null);

  const [isBannerOpen, setIsBannerOpen] = useState(false);

  const openBannerModal = () => {
    setIsBannerOpen(!isBannerOpen);
  };

  const totalQuizMins = 1;

  const getQuizSeconds = (mins) => {
    if (currentTrivia && currentTrivia.questions) {
      let validQuestions = currentTrivia.questions.filter(
        (x) => x.question_type == "MCQ"
      );

      let otherQuestions = currentTrivia.questions.filter(
        (x) => x.question_type == "TEXT" || x.question_type == "LINEAR_NUMERIC"
      );

      if (trivvyFromCustomTemplates(currentTrivia)) {
        return 0;
      }

      if (validQuestions.length && otherQuestions.length) {
        return "MCQ_MIXED";
      }

      if (validQuestions.length >= 3) {
        return mins * 60;
      } else {
        return 20 * validQuestions.length;
      }
    }
  };

  const ifMixedTimedMcqTrivvy = () => {
    if (currentTrivia && currentTrivia.questions) {
      let validQuestions = currentTrivia.questions.filter(
        (x) => x.question_type == "MCQ"
      );

      let otherQuestions = currentTrivia.questions.filter(
        (x) => x.question_type == "TEXT" || x.question_type == "LINEAR_NUMERIC"
      );

      if (validQuestions.length && otherQuestions.length) {
        return true;
      }
    }
    return false;
  };

  const isMixedTimedMcqTrivvy = ifMixedTimedMcqTrivvy();

  const totalQuizSeconds = getQuizSeconds(totalQuizMins);

  const renderQText = (text) => {
    const maxLimit = 20;
    if (text.length > maxLimit) {
      const text_compress = text.substring(0, maxLimit) + "...";

      return text_compress;
    } else {
      return text;
    }
  };

  useEffect(() => {
    if (currentQuestion && questions) {
      const newCurrent = questions.find(
        (x) => x.question_id === currentQuestion.question_id
      );
      if (newCurrent) {
        setCurrentQuestion(newCurrent);
      }
    }
  }, [questions]);

  function handlePasteEvent(event) {
    // Prevent the default paste behavior
    console.log(event.target.classList.toString());
    event.preventDefault();

    // Get the clipboard data as plain text
    const text = event.clipboardData.getData("text/plain");

    // Insert the text at the current cursor position in the active element
    if (
      document.activeElement.tagName === "INPUT" ||
      document.activeElement.tagName === "TEXTAREA"
    ) {
      // Insert text into an input or textarea
      document.activeElement.setRangeText(
        text,
        document.activeElement.selectionStart,
        document.activeElement.selectionEnd,
        "end"
      );
    } else {
      // Insert text into other editable content like contenteditable div
      document.execCommand("insertText", false, text);
    }
  }

  useEffect(() => {
    setCurrentTrivvyComments({});
    if (document.getElementById("trivvy_edit_page")) {
      document
        .getElementById("trivvy_edit_page")
        .addEventListener("paste", handlePasteEvent);
    }

    return () => {
      if (document.getElementById("trivvy_edit_page")) {
        document
          .getElementById("trivvy_edit_page")
          .removeEventListener("paste", handlePasteEvent);
      }
    };
  }, []);

  // The OrgUserMetadata.fileName is stored as
  // "<originalName> - users-<orgId>-<timestamp>_<YYYY-MM-DD>.<ext>".
  // Strip everything from " - users-" onward so the admin sees the original
  // file name they uploaded (e.g. "users-testv2") instead of the long
  // storage-mangled name.
  const getOriginalUserFileName = (storedName) => {
    if (!storedName) return "";
    const idx = storedName.indexOf(" - users-");
    if (idx > 0) {
      return storedName.substring(0, idx);
    }
    return storedName;
  };

  const getMetaData = async (publishedDate) => {
    try {
      console.log('Fetching metadata for publishedDate:', publishedDate);
      const response = await axios.get(
        `${url.getOrgUserMetaData}?publishedDate=${encodeURIComponent(
          publishedDate
        )}`
      );
      console.log('Metadata API response:', response);
      if (response && response.data && response.data.data && response.data.data.data) {
        // Store the S3 URL from the metadata response
        const metaData = response.data.data.data;
        console.log('Metadata data:', metaData);
        if (metaData.s3Url) {
          console.log('Setting S3 URL:', metaData.s3Url);
          setMetaDataS3Url(metaData.s3Url);
          setUploadedAt(metaData.uploadedAt);
          setLatestFileName(metaData.fileName);
          setMetaDataId(metaData._id);
        } else {
          console.log('No s3Url found in metadata response');
        }
      } else {
        console.log("Error fetching metadata: ", response);
      }
    } catch (err) {
      console.log("Error in getMetaData:", err);
    }
  };

  // Fetch metadata when component mounts if trivia is published
  useEffect(() => {
    if (currentTrivia && currentTrivia.isPublished && currentTrivia.publishedDate) {
      getMetaData(currentTrivia.publishedDate);
    }
  }, [currentTrivia && currentTrivia.publishedDate, currentTrivia && currentTrivia.isPublished]);

  const editQuestion = (data, key) => {
    // setCurrentQuestion(data);
    console.log({ data, key });
    const questionsArr = [...questions];
    const currentindex = questionsArr.findIndex(
      (x) => x.question_id == currentQuestion.question_id
    );

    questionsArr[currentindex] = { ...data };
    setCurrentTriviaQuestions(questionsArr);

    debounceAutoSaveData("questions", questionsArr, {
      key,
      question_id: currentQuestion.question_id,
    });
  };

  const editQuestionData = (data, key) => {
    // setCurrentQuestion(data);
    const questionsArr = [...questions];
    const currentindex = questionsArr.findIndex(
      (x) => x.question_id == data.question_id
    );

    questionsArr[currentindex] = { ...data };
    // console.log("questionsArr",questionsArr)
    // setCurrentTriviaQuestions(questionsArr);

    //   debounceAutoSaveData("questions", questionsArr, {
    //     key,
    //     question_id: data.question_id,
    //   });
  };

  const updateTriviaComments = (id, val) => {
    setCurrentTrivvyComments({
      ...currentTrivvyComments,
      [id]: val,
    });
  };

  const regenerateQuestion = (question, difficulty) => {
    setQuestionPopoverOpen(null);
    if (isTrivvyGeneratedFromCustomTemplates(currentTrivia)) {
      axios
        .post(url.regenerateTrivvyQuestionsForCustomTemplates, {
          triviaId: currentTrivia._id,
          singleQuestionRegenerateId: question.question_id,
          questionIndex: question.order,
        })
        .then(({ data }) => {
          const questions = data.data.trivia.questions;
          toastContainer("Regeneratred successfully!", "success");
          setCurrentTriviaQuestions(questions);
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .post(url.regenerateQuestionForTrivvy, {
          triviaId: currentTrivia._id,
          currentQuestion: question,
          difficultyLevel: difficulty || 2,
        })
        .then(({ data }) => {
          const questions = data.data.trivia.questions;
          toastContainer("Regenerated successfully!", "success");
          setCurrentTriviaQuestions(questions);
        })
        .catch((err) => console.log(err));
    }
  };

  const regenerateAllAiQuestions = () => {
    if (isTrivvyGeneratedFromCustomTemplates(currentTrivia)) {
      axios
        .post(url.regenerateTrivvyQuestionsForCustomTemplates, {
          triviaId: currentTrivia._id,
          allRegenerate: true,
        })
        .then(({ data }) => {
          const questions = data.data.trivia.questions;
          setCurrentTriviaQuestions(questions);
          setCurrentQuestion("WELCOME");
          toastContainer("Regeneratred successfully!", "success");
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .post(url.generateTriviaQuestions, {
          trivia: currentTrivia,
          regenerate: true,
          question_count: currentTrivia.questions.filter(
            (x) => x.is_ai_generated === true && x.question_type == "MCQ"
          ).length,
        })
        .then(({ data }) => {
          const questions = data.data.trivia.questions;
          setCurrentTriviaQuestions(questions);
          setCurrentQuestion("WELCOME");
          toastContainer("Regeneratred successfully!", "success");
        })
        .catch((err) => console.log(err));
    }
  };
  const addNewAiQuestion = () => {

    axios
      .post(url.generateTriviaQuestions, {
        trivia: currentTrivia,
        question_count: 1,
        isNew: true,
      })
      .then(({ data }) => {
        let questions = data.data.trivia.questions;
        questions = formatQuestionsNumberWise(questions);
        setCurrentTriviaQuestions(questions);
        setCurrentQuestion(questions[questions.length - 1]);
        toastContainer("New question generated successfully!", "success");
      })
      .catch((err) =>{if(err.response&& err.response.data&&err.response.data.message) toastContainer(err.response.data.message,'error')});
  };

  const editQuestionOptionsSync = (data) => {
    // setCurrentQuestion(data);
    const questionsArr = [...questions];

    const currentindex = questionsArr.findIndex(
      (x) => x.question_id == currentQuestion.question_id
    );
    questionsArr[currentindex] = data;
    callApiToAutoSave("questions", questionsArr, (resType, message) => {
      if (resType === "SUCCESS") {
        setCurrentTriviaQuestions(questionsArr);
      } else {
        toastContainer(message, "error");
      }
    });
  };

  const generateOptionId = (text, order) => {
    return `${uuidv4()}${order}?${hashText(`${text}`)}?${currentTrivia._id}?${
      user.profile.organizationId._id
    }`;
  };

  const addNewQuestion = () => {
    // Check if trivia is published
    if (currentTrivia && currentTrivia.isPublished) {
      toastContainer("You can not add a question to a Published Trivvy", "error");
      return;
    }

    const questionsArr = [...questions];

    setQuestionCreateLoading(true);

    const data = getNewQuestionEmptyObject(
      currentTrivia,
      user.profile.organizationId._id,
      questionsArr.length + 1,
      "MCQ"
    );

    questionsArr.push(data);

    const newQArr = formatQuestionsNumberWise(questionsArr);

    callApiToAutoSave("questions", newQArr, (resType, message) => {
      if (resType === "SUCCESS") {
        setQuestionCreateLoading(false);
        setCurrentTriviaQuestions(newQArr);
        setCurrentQuestion(newQArr[newQArr.length - 1]);
      } else {
        setQuestionCreateLoading(false);
        toastContainer(message, "error");
      }
    });
  };

  const handleDeleteQuestion = (id) => {
    setQuestionPopoverOpen(null);
    const questionsArr = [...questions].filter((x) => x.question_id != id);
    setCurrentQuestion("WELCOME");
    const formatArr = formatQuestionsNumberWise(questionsArr);
    setCurrentTriviaQuestions(formatArr);
    callApiToAutoSave("questions", formatArr);
  };

  const onSortEnd = (oldIndex, newIndex) => {
    if (isEditable && questionEditable) {
      const sortedArray = arrayMoveImmutable(questions, oldIndex, newIndex);
      const q_order_arr = formatQuestionsNumberWise(sortedArray);

      setCurrentTriviaQuestions(q_order_arr);
      callApiToAutoSave("questions", q_order_arr);
    } else {
      toastContainer(PUBLISH_SAVE_ERROR, "error");
    }
  };

  const editWelcomeData = (data) => {
    console.log("hh", data);
    editCurrentTriviaWelcomeData(data);
  };

  const editEndingData = (data) => {
    editCurrentTriviaEndingData(data);
  };

  const changeThemeSettings = (key, value) => {
    if (rightSidebarThemeSettings) {
      const themeData = {
        ...rightSidebarThemeSettings,
        [key]: ["quizBackgroundColor", "quizTextColor"].includes(key)
          ? value.indexOf("#") >= 0
            ? value
            : value
          : value,
      };

      if (currentQuestion && typeof currentQuestion != "string") {
        editQuestion(
          { ...currentQuestion, theme_settings: themeData },
          "theme_settings"
        );
      } else if (currentQuestion === "WELCOME") {
        editCurrentTriviaThemeData({ type: "WELCOME", themeData });
        callApiToAutoSave("themeSettings", themeData);
      } else if (currentQuestion === "RATING") {
        editCurrentTriviaThemeData({ type: "RATING", themeData });
        callApiToAutoSave("themeSettingsRatingPage", themeData);
      } else if (currentQuestion === "ENDING") {
        editCurrentTriviaThemeData({ type: "ENDING", themeData });
        callApiToAutoSave("themeSettingsEndingPage", themeData);
      }
    }
  };

  const changeStartButtonColor = (key, value) => {
    if (currentTrivia && currentTrivia.welcomePage) {
      const welcomeDataNew = {
        ...currentTrivia.welcomePage,
        startButtonSettings: {
          ...currentTrivia.welcomePage.startButtonSettings,
          [key]: value,
        },
      };

      editCurrentTriviaWelcomeData(welcomeDataNew);
      callApiToAutoSave("welcomePage", welcomeDataNew);
    }
  };

  const editRatingData = (value, key) => {
    const data = {
      ...currentTrivia.ratingPage,
      [key]: value,
    };

    setCurrentTrivia({ ...currentTrivia, ratingPage: data });
    callApiToAutoSave("ratingPage", data);
  };

  const applyThemeSettingsToAllPages = (themeData) => {
    if (themeData.quizBackgroundColor == null) {
      themeData.quizBackgroundColor = THEME_SETTING.quizBackgroundColor;
    }
    if (themeData.quizTextColor == null) {
      themeData.quizTextColor = THEME_SETTING.quizTextColor;
    }
    const questionsArr = currentTrivia.questions.map((q) => ({
      ...q,
      theme_settings: themeData,
    }));

    setCurrentTriviaQuestions(questionsArr);
    editCurrentTriviaThemeData({ type: "WELCOME", themeData });
    editCurrentTriviaThemeData({ type: "RATING", themeData });
    editCurrentTriviaThemeData({ type: "ENDING", themeData });
    callApiToAutoSave("questions", questionsArr);
    callApiToAutoSave("themeSettingsRatingPage", themeData);
    callApiToAutoSave("themeSettingsEndingPage", themeData);
    callApiToAutoSave("themeSettings", themeData);
  };

  const callApiToAutoSave = (key, data, cb) => {
    console.log("updating----", { key, data });
    const payload = {
      [key]: data,
    };

    const updatedObj = { updateData: payload };

    if (cb && typeof cb != "function") {
      updatedObj.changedKey = cb.key;
      updatedObj.up_question_id = cb.question_id;
    }
    // if (currentTrivia) {
    axios
      .put(url.editTrivia(props.match.params.id), updatedObj)
      .then((res) => {
        if (cb && typeof cb == "function") {
          console.log('res.data.data.trivia -- ', res.data.data.trivia)
          cb("SUCCESS", res.data.data.trivia);
        }
        // if (key == "questions") {
        //   setCurrentTrivia({
        //     ...currentTrivia,
        //     questions: res.data.data.trivia.questions,
        //   });
        // }
      })
      .catch((err) => {
        if (cb && typeof cb == "function") {
          cb(
            "ERROR",
            err.response.data &&
              err.response.data.errors &&
              err.response.data.errors.message
          );
        }
        console.log(err);
      });
    // }
  };

  const debounceAutoSaveData = useCallback(
    debounce(callApiToAutoSave, 3000),
    []
  );

  const rightSidebarThemeSettings =
    currentQuestion && currentTrivia
      ? getThemeSettingsForPage(currentTrivia, currentQuestion)
      : THEME_SETTING;

  const handleSelectCorrect = (option, value) => {
    if (isEditable && questionEditable) {
      if (value) {
        const data = {
          ...currentQuestion,
          correct_options: [{ ...option, is_correct: true }],
          options: currentQuestion.options.map((x) => ({
            ...x,
            is_correct: option.option_id == x.option_id ? true : false,
          })),
        };
        editQuestion(data, "correct_options");
      } else {
        const data = {
          ...currentQuestion,
          correct_options: [],
        };
        editQuestion(data, "correct_options");
      }
    } else {
      toastContainer(PUBLISH_SAVE_ERROR, "error");
    }
  };

  const fileName = getTriviaFileName(currentTrivia);

  const applyToAllPages = currentTrivia
    ? isThemeSettingsAppliedToAllPages(currentTrivia)
    : false;

  const showLinkedButton = () => {
    console.log("linkedBtn ---- ", currentTrivia);
    if (currentTrivia && currentTrivia.triviaCategoryType) {
      let category = currentTrivia.triviaCategoryType;
      console.log("category ---- ", category);
      if (category == "REWARD") {
        //  return currentTrivia && currentTrivia.linkedTrivvys && currentTrivia.linkedTrivvys.length>0? "Change trivia": "Link trivia"
        return "Manage Trivia";
      } else {
        // return currentTrivia && currentTrivia.linkedTrivvys && currentTrivia.linkedTrivvys.length>0?  "Change reward":"Link reward"
        return "Manage Rewards";
      }
    }
  };

  const addNewCustomInputQuestion = () => {
    const questionsArr = [...questions];

    setQuestionCreateLoading(true);

    const data = getNewQuestionEmptyObject(
      currentTrivia,
      user.profile.organizationId._id,
      questionsArr.length + 1,
      "CUSTOM"
    );

    questionsArr.push(data);

    const newQArr = formatQuestionsNumberWise(questionsArr);

    callApiToAutoSave("questions", newQArr, (resType, message) => {
      if (resType === "SUCCESS") {
        setQuestionCreateLoading(false);
        setCurrentTriviaQuestions(newQArr);
      } else {
        setQuestionCreateLoading(false);
        toastContainer(message, "error");
      }
    });
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const rephraseQuestionApi = (topic) => {
    axios
      .post(url.rephraseCustomQuestion, {
        currentQuestion: currentQuestion,
        topic: topic,
        triviaId: currentTrivia._id,
      })
      .then(({ data }) => {
        const trivia = data.data.trivia;
        setCurrentTrivia({
          ...currentTrivia,
          questions: trivia.questions,
        });
      })
      .catch((err) => {
        toastContainer("Error occured while assisting");
      });
  };

  const editTrivvyByKey = (key, value) => {
    const data = { ...currentTrivia, [key]: value };
    setCurrentTrivia(data);
  };

  useEffect(() => {
    if (typeof currentQuestion === "string") {
      setShowStyleTheme(false);
      setShowQuestionDG(false);
    }
  }, [currentQuestion]);

  useEffect(() => {
    if (currentQuestion.question_id) {
      setShowStyleTheme(false);
      setShowQuestionDG(false);
    }
  }, [currentQuestion.question_id]);

  const holidayTemplateName =
    currentTrivia &&
    currentTrivia.generatedFromTemplate &&
    currentTrivia.generatedFromTemplate.name
      ? currentTrivia.generatedFromTemplate.name
      : "";

  let allCommentsCount = 0;

  let allCommentsArray = [];
  if (currentTrivia) {
    if (currentTrivia.welcomePage) {
      allCommentsCount += currentTrivia.welcomePage.commentsCount
        ? currentTrivia.welcomePage.commentsCount
        : 0;

      allCommentsArray = [
        ...allCommentsArray,
        ...(currentTrivvyComments["WELCOME"] || []),
      ];
    }

    if (currentTrivia.endingPage) {
      allCommentsCount += currentTrivia.endingPage.commentsCount
        ? currentTrivia.endingPage.commentsCount
        : 0;
      allCommentsArray = [
        ...allCommentsArray,
        ...(currentTrivvyComments["ENDING"] || []),
      ];
    }

    if (currentTrivia.ratingPage) {
      allCommentsCount += currentTrivia.ratingPage.commentsCount
        ? currentTrivia.ratingPage.commentsCount
        : 0;
      allCommentsArray = [
        ...allCommentsArray,
        ...(currentTrivvyComments["RATING"] || []),
      ];
    }

    if (currentTrivia.questions && currentTrivia.questions.length) {
      for (const q of currentTrivia.questions) {
        allCommentsCount += q.commentsCount ? q.commentsCount : 0;
        allCommentsArray = [
          ...allCommentsArray,
          ...(currentTrivvyComments[q.question_id] || []),
        ];
      }
    }
  }

  const handleAllCommentsUpdate = (docs) => {
    const mainObj = {
      ...currentTrivvyComments,
    };
    const welcomeComments = docs.filter((x) => x.questionId == "WELCOME");
    const ratingComments = docs.filter((x) => x.questionId == "RATING");
    const endingComments = docs.filter((x) => x.questionId == "ENDING");

    mainObj["WELCOME"] = welcomeComments;
    mainObj["RATING"] = ratingComments;
    mainObj["ENDING"] = endingComments;

    callApiToAutoSave("welcomePage", {
      ...currentTrivia.welcomePage,
      commentsCount: welcomeComments.length,
    });

    callApiToAutoSave("ratingPage", {
      ...currentTrivia.ratingPage,
      commentsCount: ratingComments.length,
    });

    callApiToAutoSave("endingPage", {
      ...currentTrivia.endingPage,
      commentsCount: endingComments.length,
    });

    const quesData = currentTrivia.questions.map((question) => {
      const c_q_comments = docs.filter(
        (x) => x.questionId == question.question_id
      );
      mainObj[question.question_id] = c_q_comments;
      editQuestionData(
        { ...question, commentsCount: c_q_comments.length },
        "commentsCount"
      );
      return {
        ...question,
        commentsCount: c_q_comments.length,
      };
    });

    setCurrentTrivia({
      ...currentTrivia,
      welcomePage: {
        ...currentTrivia.welcomePage,
        commentsCount: welcomeComments.length,
      },
      endingPage: {
        ...currentTrivia.endingPage,
        commentsCount: endingComments.length,
      },
      ratingPage: {
        ...currentTrivia.ratingPage,
        commentsCount: ratingComments.length,
      },
      questions: quesData,
    });

    setCurrentTrivvyComments(mainObj);
  };

  const getCommentPageNumber = (comment) => {
    if (currentTrivia && currentTrivia.questions) {
      if (comment.questionId === "WELCOME") {
        return 1;
      } else if (comment.questionId === "RATING") {
        return currentTrivia.questions.length + 1;
      } else if (comment.questionId === "ENDING") {
        return currentTrivia.questions.length + 2;
      } else {
        const qIndex = currentTrivia.questions.findIndex(
          (x) => x.question_id == comment.questionId
        );
        return qIndex + 2;
      }
    }
  };

  const goToClickedPage = (pageId) => {
    if (pageId === "WELCOME") {
      setCurrentQuestion("WELCOME");
    } else if (pageId === "ENDING") {
      setCurrentQuestion("ENDING");
    } else if (pageId === "RATING") {
      setCurrentQuestion("RATING");
    } else {
      const questionDoc = questions.find((x) => x.question_id == pageId);

      if (questionDoc) {
        setCurrentQuestion(questionDoc);
      }
    }
  };

  const getCustomTemplateDataHtml = () => {
    if (currentTrivia) {
      return (
        <ul>
          {currentTrivia.customTemplateData.industry ? (
            <li>
              {" "}
              <b> Industry: </b>
              {currentTrivia.customTemplateData.industry}
            </li>
          ) : (
            ""
          )}
          {currentTrivia.customTemplateData.jobCategory ? (
            <li>
              <b>Job category: </b>{" "}
              {currentTrivia.customTemplateData.jobCategory}
            </li>
          ) : (
            ""
          )}
          {currentTrivia.customTemplateData.occupation ? (
            <li>
              {" "}
              <b>Occupation: </b> {currentTrivia.customTemplateData.occupation}
            </li>
          ) : (
            ""
          )}
          {currentTrivia.customTemplateData.workFlexibility ? (
            <li>
              <b>Work flexibility: </b>
              {currentTrivia.customTemplateData.workFlexibility}
            </li>
          ) : (
            ""
          )}
        </ul>
      );
    } else {
      return <span></span>;
    }
  };

  const scheduleDateUpdate = (date) => {
    setCurrentTrivia({
      ...currentTrivia,
      scheduledDate: date,
    });

    // Hit the Advanced Settings endpoint so the BE normalizes scheduledDate
    // to the top of the hour in UTC per TBV-624 hot fix (instead of /edit-trivia/:id which doesn't normalize).
    const payload = {
      minimumPassingPercent: currentTrivia.minimumPassingPercent,
      timedQuestionsEnable: currentTrivia.timedQuestionsEnable,
      adminEmailTriggerType: currentTrivia.adminEmailTriggerType,
      reminderNotificationFrequency: currentTrivia.reminderNotificationFrequency,
      weeklyFrequencyDayOfWeek: currentTrivia.weeklyFrequencyDayOfWeek,
      isReminderUpdated: false,
      triviaId: currentTrivia._id,
      numberOfAttempts: currentTrivia.numberOfAttempts,
      allowAttempts: currentTrivia.allowAttempts,
      allowAnonymousResponses: currentTrivia.allowAnonymousResponses,
      anonymousDefaultOn: currentTrivia.anonymousDefaultOn,
      scheduledDate: date,
      randomizeQuestions: currentTrivia.randomizeQuestions,
      trivvyEndDate: currentTrivia.trivvyEndDate,
      sendResultSummaryAsTextAfterTrivvyEnds: currentTrivia.sendResultSummaryAsTextAfterTrivvyEnds,
      notifyAdminWhenUserRepliesToMessages: currentTrivia.notifyAdminWhenUserRepliesToMessages,
    };

    axios
      .post(url.updateAdvancedTrivvySettings, payload)
      .then(({ data }) => {
        // Sync with the server-normalized scheduledDate (top of hour in UTC per TBV-624)
        if (data && data.data && data.data.scheduledDate !== undefined) {
          setCurrentTrivia({
            ...currentTrivia,
            scheduledDate: data.data.scheduledDate,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error while updating scheduled date", "error");
      });
  };
  const leftUI = () => {
    return (
      <div
        style={{
          height: "100%",
          overflowY: "auto",
          ...(isMobile && { fontSize: "10px" }),
          paddingLeft: "8px",
        }}
        className="scrollMobileNoScrollPc"
      >
        <div className="TriviaEditViewListUI_leftContainer_content px-2 pt-2">
          <span>Content</span>
          <div>
            {isEditable && questionEditable && (
              <UncontrolledDropdown>
                <DropdownToggle
                  size="sm"
                  className={`${
                    !isMobile ? "trivia-action-button-secondary" : ""
                  } trivia-btn-action-btn-options-dd btn-sm px-1 mr-2`}
                  disabled={!isEditable}
                  tag="span"
                >
                  <BsThreeDotsVertical />
                </DropdownToggle>
                <DropdownMenu>
                  {/* <DropdownItem onClick={() => addNewAiQuestion()}>
                    New AI Question
                  </DropdownItem> */}
                  <DropdownItem onClick={addNewQuestion}>
                    New Custom Question
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </div>
        </div>

        {currentTrivia && currentTrivia.createdBy && (
          <div className="px-2 mt-1 font-11px">
            <div className="d-flex align-items-center greytextCreatedby">
              <div>
                {" "}
                By
                <span style={{ marginLeft: "5px" }}>
                  {!currentTrivia.createdBy.firstName &&
                  !currentTrivia.createdBy.lastName &&
                  currentTrivia.createdBy.status == "INACTIVE" ? (
                    <span>Inactive user</span>
                  ) : (
                    <span>
                      {currentTrivia.createdBy.firstName || "User"}{" "}
                      {currentTrivia.createdBy.lastName}
                    </span>
                  )}
                </span>
                <div>
                  {" "}
                  created on{" "}
                  {moment(currentTrivia.createdOn).format("MMM D, YYYY")}{" "}
                </div>
              </div>
            </div>

            {isEditable && (
              <div
                class="TriviaEditViewListUI_leftContainer_singleQuestion my-0 mt-4"
                onClick={() => {
                  if (isEditable) {
                    setAdvanceSettingModal(true);
                  }
                }}
              >
                <div class="TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey tSettings_leftContainer_edit">
                  <span class="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                    <BsFillGearFill size={16} />
                  </span>
                </div>
                <div style={{ fontSize: "12px" }}>Settings</div>
              </div>

              // <div
              //     className={"cursor-pointer edit_trivvy_settings_txt"}
              //     onClick={() => {
              //       if (isEditable) {
              //         setAdvanceSettingModal(true);
              //       }
              //     }}
              //   >
              //     <div class="cursor-pointer edit_trivvy_settings_txt TriviaEditViewListUI_leftContainer_singleQuestion tSettings_leftContainer_edit">
              //       <span class="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
              //         <BsFillGearFill className="ml-1" />
              //       </span>
              //     </div>

              //     <div> Settings </div>

              // </div>
            )}
          </div>
        )}

        <div className="TriviaEditViewListUI_leftContainer_TopUi p-2">
          <div className="TriviaEditViewListUI_leftContainer_questionsUI">
            <div
              className="TriviaEditViewListUI_leftContainer_singleQuestion"
              onClick={() => setCurrentQuestion("WELCOME")}
            >
              <div>
                <div
                  className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey`}
                >
                  <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                    <BsFillBookmarksFill size={18} />
                  </span>
                </div>
              </div>

              <div>
                {currentTrivia.welcomePage
                  ? renderQText(currentTrivia.name)
                    ? parse(renderQText(currentTrivia.name || "Welcome Page"))
                    : "Welcome Page"
                  : "No text ... "}
              </div>

              <span className="TriviaEditViewListUI_leftContainer_singleQuestion_Comments ml-3">
                {renderCommentsCountTextFormat(
                  currentTrivia.welcomePage.commentsCount
                )}{" "}
                <FaRegComment size="9px" />{" "}
              </span>
            </div>

            <SortableList onSortEnd={onSortEnd} draggedItemClassName="dragged" >
              {questions &&
                questions.map((question) => {
                  console.log(question,'question is here')
                  const odd_or_eve = question.order % 2 == 0 ? "even" : "odd";
                  return (
                    <SortableItem key={question.question_id}>
                      <div
                        className={`TriviaEditViewListUI_leftContainer_singleQuestion ${
                          question.question_id == currentQuestion.question_id
                            ? "selected"
                            : ""
                        }`}
                        onMouseEnter={() =>
                          setHoveredQuestion(question.question_id)
                        }
                        onMouseLeave={() => setHoveredQuestion(null)}
                        onClick={() => {
                          if(question && question.users_responded > 0) {
                            toastContainer("Users have already taken this Trivvy. You can no longer edit the questions.","error");
                          }
                          setCurrentQuestion(question)
                        } }
                      >
                        <div>
                          <div
                            className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve}
                      `}
                            style={{
                              backgroundColor:
                                question.theme_settings.quizBackgroundColor,
                              color: question.theme_settings.quizTextColor,
                            }}
                          >
                            {/* <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                                {" "}
                                {odd_or_eve == "odd" ? (
                                  <BiHash size={18} />
                                ) : (
                                  <BiCheck size={18} />
                                )}{" "}
                              </span>{" "} */}
                            <span>{question.order}</span>
                          </div>{" "}
                        </div>
                        <div style={{ flex: 1 }}>
                          {renderQText(question.question_text)
                            ? renderQText(
                                contvertHTMLToPlain(question.question_text)
                              )
                            : ""}
                          {question.is_ai_generated ? (
                            <div className="trivia-ai-gen-q">AI Generated</div>
                          ) : null}

                          {question.difficultyLevel &&
                          question.is_ai_generated &&
                          !currentTrivia.isBuiltInWithAiType ? (
                            <div style={{ flex: 1, color: "GrayText" }}>
                              Difficulty:{" "}
                              {getDifficultyLevels(question.difficultyLevel)}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <span className="TriviaEditViewListUI_leftContainer_singleQuestion_Comments">
                          {renderCommentsCountTextFormat(
                            question.commentsCount
                          )}{" "}
                          <FaRegComment size="9px" />{" "}
                        </span>

                        <div>
                          {isEditable && questionEditable ? (
                            // (isEditable &&
                            //   hoveredQuestion == question.question_id) ||
                            // questionPopoverOpen === question.question_id ?
                            <div
                              className={
                                "TriviaEditViewListUI_leftContainer_singleQuestion_hoveractive"
                              }
                            >
                              <span
                                onClick={() =>
                                  setQuestionPopoverOpen(question.question_id)
                                }
                                className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper"
                                id={`trivia_threedots_wrapper_${
                                  question.question_id.split("?")[0]
                                }`}
                              >
                                <BsThreeDotsVertical />
                              </span>
                              <Popover
                                isOpen={
                                  questionPopoverOpen === question.question_id
                                }
                                target={`trivia_threedots_wrapper_${
                                  question.question_id.split("?")[0]
                                }`}
                                placement="bottom"
                                hideArrow
                                toggle={() => setQuestionPopoverOpen(null)}
                              >
                                <PopoverBody>
                                  <div
                                    className="dropdown-item my-1 cursor-pointer text-danger"
                                    onClick={() =>
                                      handleDeleteQuestion(question.question_id)
                                    }
                                  >
                                    Delete <BiTrashAlt className="ml-2" />
                                  </div>
                                  {/* {question.is_ai_generated && (
                                    <>
                                      <div
                                        className="dropdown-item my-1 cursor-pointer"
                                        style={{
                                          opacity:
                                            2 - question.regeneratedTimes > 0
                                              ? 1
                                              : 0.5,
                                          pointerEvents:
                                            2 - question.regeneratedTimes > 0
                                              ? "auto"
                                              : "none",
                                        }}
                                        onClick={() => {
                                          if (
                                            2 - question.regeneratedTimes >
                                            0
                                          ) {
                                            regenerateQuestion(
                                              question,
                                              question.difficultyLevel
                                            );
                                          }
                                        }}
                                      >
                                        Regenerate (
                                        {2 - question.regeneratedTimes}){" "}
                                        <BiRecycle className="ml-2" />
                                      </div>
                                    </>
                                  )} */}
                                </PopoverBody>
                              </Popover>
                            </div>
                          ) : (
                            <div className="TriviaEditViewListUI_leftContainer_singleQuestion_hover"></div>
                          )}
                        </div>
                      </div>
                    </SortableItem>
                  );
                })}
            </SortableList>

            
          </div>

          {/* {currentTrivia && (currentTrivia.triviaType == 2 || (currentTrivia.questions && currentTrivia.question.length < 5) ) ? ( */}
             
            {/* // ) : (
            //   ""
            // )} */}
            {console.log("current trivvia:",currentTrivia)}
            <div>
              {currentTrivia.triviaType==2?<Button onClick={addNewQuestion}
                style={{
                  opacity: currentTrivia && currentTrivia.isPublished ? 0.5 : 1
                }}
              > 
                +
                </Button>:
              <UncontrolledDropdown>
                <DropdownToggle
               
                  size="sm"
                  className={`${
                    !isMobile ? "trivia-action-button-secondary" : ""
                  } trivia-btn-add-que btn-sm  w-25 d-flex justify-content-center`}
                  disabled={!isEditable}
                  tag="div"
                >
            
                +
                </DropdownToggle>
                <DropdownMenu>
                 
                  <DropdownItem onClick={() =>addNewQuestion() }>
                    Add Question
                  </DropdownItem>
                  {/* <DropdownItem onClick={()=>addNewAiQuestion()}>
                    Add AI Question
                  </DropdownItem> */}
                 
                </DropdownMenu>
              </UncontrolledDropdown>}
            </div>


          <div className="mt-4 font-13px">
            {allCommentsCount}{" "}
            <FaRegComment
              style={{
                height: "15px",
                width: "13px",
                verticalAlign: "text-top",
              }}
            />{" "}
            comments total{" "}
            <b
              className="text-info cursor-pointer"
              onClick={() => {
                setAllCommentsPopoverOpen(true);
              }}
              id={`comments-popover-all`}
            >
              (view)
            </b>
            {allCommentsPopoverOpen && (
              <TriviaCommentsComponent
                commentsPopoverOpen={allCommentsPopoverOpen}
                setCommentsPopoverOpen={setAllCommentsPopoverOpen}
                target={`comments-popover-all`}
                comments={allCommentsArray}
                setComments={(docs) => {
                  handleAllCommentsUpdate(docs);
                }}
                questionId={"ALL"}
                triviaId={currentTrivia._id}
                getCommentPageNumber={getCommentPageNumber}
                goToClickedPage={goToClickedPage}
              />
            )}
          </div>

          {holidayTemplateName ? (
            <div className="TriviaEditViewListUI_leftContainer_uploadedURL">
              These questions were generated on template{" "}
              <b>{holidayTemplateName}</b>
            </div>
          ) : currentTrivia.uploadUrl &&
            currentTrivia.uploadUrl != "" &&
            currentTrivia.uploadUrl != null ? (
            <div className="TriviaEditViewListUI_leftContainer_uploadedURL">
              These questions were generated based on{" "}
              <a
                href="#"
                onClick={function(e) {
                  e.preventDefault();
                  var triviaId = currentTrivia && currentTrivia._id;
                  if (triviaId) {
                    axios.get(url.getSignedUrl, {
                      params: { id: triviaId, model: 'TriviaTemplate', inline: 1 }
                    }).then(function(res) {
                      var signedUrl = res.data && res.data.url;
                      if (signedUrl) {
                        window.open(signedUrl, '_blank');
                      } else {
                        window.open(currentTrivia.uploadUrl, '_blank');
                      }
                    }).catch(function() {
                      window.open(currentTrivia.uploadUrl, '_blank');
                    });
                  } else {
                    window.open(currentTrivia.uploadUrl, '_blank');
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                Link
              </a>
            </div>
          ) : currentTrivia &&
            currentTrivia.uploadType == 2 &&
            currentTrivia.uploadText ? (
            <div className="TriviaEditViewListUI_leftContainer_uploadedURL">
              These questions were generated based on{" "}
              <b
                className="text-info cursor-pointer"
                onClick={() => setCustomTextModal(true)}
              >
                Custom Text
              </b>
            </div>
          ) : currentTrivia &&
            trivvyFromCustomTemplates(currentTrivia) &&
            currentTrivia.customTemplateData ? (
            <div className="TriviaEditViewListUI_leftContainer_uploadedURL">
              These questions were generated based on template{" "}
              <b>{TEMPLATE_TYPE_MAP[currentTrivia.templateType]}</b> with the
              following parameters:
              {getCustomTemplateDataHtml()}
            </div>
          ) : (
            ""
          )}

          <Modal isOpen={customTextModal}>
            <ModalHeader
              className="trivia_modal_header_bg"
              toggle={() => setCustomTextModal(false)}
            >
              Custom Text
            </ModalHeader>
            <ModalBody className="p-3">{currentTrivia.uploadText}</ModalBody>
          </Modal>

          <div className="mt-4">
            {currentTrivia.isPublished && currentTrivia.publishedDate && (
              <>
                This Trivvy was published on{" "}
                {moment(currentTrivia.publishedDate).format("MMM D, YYYY [at] h:mm A")}{" "}
              </>
            )}
          </div>
          {metaDataS3Url && currentTrivia.isPublished && (
            <div className="mt-2">
              <p className="mb-1">
                <span style={{ whiteSpace: "nowrap" }}>
                  {APPLICABLE_USER_FILE_LABEL}
                  <OoPopover
                    target="applicable_user_file_tooltip"
                    headerText="Applicable user file"
                    bodyText={APPLICABLE_USER_FILE_TOOLTIP}
                    css_class="oo_popover_insights_tip"
                  />
                </span>
              </p>
              <p>
                {getOriginalUserFileName(latestFileName)}, uploaded {moment(uploadedAt).format("MMM D, YYYY")}
                <a
                  href="#"
                  onClick={function(e) {
                    e.preventDefault();
                    if (!metaDataId) return;
                    axios
                      .get(url.getSignedUrl, {
                        params: { id: metaDataId, model: "OrgUserMetadata", inline: 0 },
                      })
                      .then(function(res) {
                        var signedUrl = res.data && res.data.url;
                        if (!signedUrl) return;
                        var a = document.createElement("a");
                        a.href = signedUrl;
                        a.target = "_blank";
                        a.rel = "noopener noreferrer";
                        a.download = "";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                      })
                      .catch(function(err) {
                        console.error("Failed to get signed URL", err);
                      });
                  }}
                  className="text-info small ml-1"
                >
                  (View File)
                </a>
              </p>
            </div>
          )}
        </div>

        {currentTrivia && (
          <div className="TriviaEditViewListUI_leftContainer_bottomUi p-2">
            <div className="TriviaEditViewListUI_leftContainer_content">
              <span>Endings</span>
            </div>

            {/* {currentTrivia &&
            currentTrivia.ratingPage &&
            currentTrivia.ratingPage.display ? (
              <div
                className="TriviaEditViewListUI_leftContainer_singleQuestion"
                onClick={() => {
                  setCurrentQuestion("RATING");
                }}
              >
                <div>
                  <div
                    className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey`}
                    style={{
                      backgroundColor: currentTrivia.themeSettingsRatingPage
                        ? currentTrivia.themeSettingsRatingPage
                            .quizBackgroundColor
                        : THEME_SETTING.quizBackgroundColor,
                      color: currentTrivia.themeSettingsRatingPage
                        ? currentTrivia.themeSettingsRatingPage.quizTextColor
                        : THEME_SETTING.quizTextColor,
                    }}
                  >
                    <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                      <BsStarFill size={18} />
                    </span>
                  </div>
                </div>

                <div style={{ flex: 1 }}>Rating </div>

                <span className="TriviaEditViewListUI_leftContainer_singleQuestion_Comments">
                  {renderCommentsCountTextFormat(
                    currentTrivia.ratingPage
                      ? currentTrivia.ratingPage.commentsCount
                      : 0
                  )}{" "}
                  <FaRegComment size="9px" />{" "}
                </span>

                {isEditable && questionEditable ? (
                  <div
                    className={
                      "TriviaEditViewListUI_leftContainer_singleQuestion_hoveractive"
                    }
                  >
                    <span
                      onClick={() => setQuestionPopoverOpen("rating")}
                      className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper mr-2"
                      id={`trivia_threedots_wrapper_${"rating"}`}
                    >
                      <BsThreeDotsVertical />
                    </span>
                    <Popover
                      isOpen={questionPopoverOpen === "rating"}
                      target={`trivia_threedots_wrapper_${"rating"}`}
                      placement="bottom"
                      hideArrow
                      toggle={() => setQuestionPopoverOpen(null)}
                    >
                      <PopoverBody>
                        <div
                          className="dropdown-item my-1 cursor-pointer text-danger"
                          onClick={() => {
                            setCurrentTrivia({
                              ...currentTrivia,
                              ratingPage: {
                                ...currentTrivia.ratingPage,
                                display: false,
                              },
                            });

                            callApiToAutoSave("ratingPage", {
                              ...currentTrivia.ratingPage,
                              display: false,
                            });
                            setCurrentQuestion("WELCOME");
                            setQuestionPopoverOpen(null);
                          }}
                        >
                          Delete <BiTrashAlt className="ml-2" />
                        </div>
                      </PopoverBody>
                    </Popover>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="TriviaEditViewListUI_leftContainer_singleQuestion">
                <Button
                  className="add-rating-button-color"
                  size="sm"
                  onClick={() => {
                    setCurrentTrivia({
                      ...currentTrivia,
                      ratingPage: {
                        ...currentTrivia.ratingPage,
                        display: true,
                      },
                    });

                    callApiToAutoSave("ratingPage", {
                      ...currentTrivia.ratingPage,
                      display: true,
                    });
                    setCurrentQuestion("RATING");
                  }}
                  disabled={!isEditable || !questionEditable}
                >
                  <BsStar className="mr-2" /> Add user rating?
                </Button>
              </div>
            )} */}

            <div
              className="TriviaEditViewListUI_leftContainer_singleQuestion"
              onClick={() => {
                setCurrentQuestion("ENDING");
              }}
            >
              <div>
                <div
                  className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey`}
                >
                  <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                    <BsFillBookmarksFill size={18} />
                  </span>
                </div>
              </div>

              <div>
                {currentTrivia.endingPage
                  ? renderQText(currentTrivia.endingPage.heading)
                    ? parse(renderQText(currentTrivia.endingPage.heading))
                    : ""
                  : "No text ... "}
              </div>

              <span className="TriviaEditViewListUI_leftContainer_singleQuestion_Comments ml-3">
                {renderCommentsCountTextFormat(
                  currentTrivia.endingPage
                    ? currentTrivia.endingPage.commentsCount
                    : 0
                )}{" "}
                <FaRegComment size="9px" />{" "}
              </span>
            </div>

            {showEndDateEdit ? (
              <div className="d-flex align-items-center mt-2 trivvy-edit-end-date-container">
                <ReactDatePicker
                  minDate={moment().toDate()}
                  id="actionDueDate"
                  placeholderText="Enter date: MM/DD/YYYY"
                  className="form-control filter-action-date-input "
                  selected={
                    typeof currentTrivia.trivvyEndDate == "string"
                      ? moment(currentTrivia.trivvyEndDate).local()
                      : currentTrivia.trivvyEndDate
                  }
                  onChange={(v) => {
                    const date = moment(v).startOf("day");

                    setCurrentTrivia({
                      ...currentTrivia,
                      trivvyEndDate: date,
                    });

                    callApiToAutoSave("trivvyEndDate", date);

                    if (
                      currentTrivia.trivvyEndDate &&
                      moment(currentTrivia.trivvyEndDate).isSameOrBefore(
                        moment(),
                        "day"
                      ) &&
                      moment(date).isAfter(moment())
                    ) {
                      publishTriviaApiCall(false, null);
                    }
                  }}
                  showYearDropdown
                />

                <span>
                  {" "}
                  Done{" "}
                  <BiCheckCircle
                    onClick={() => {
                      setShowEndDatEdit(false);
                    }}
                    className="ml-0 text-danger trivvy-edit-sidebar-end-date-success-icon"
                  ></BiCheckCircle>
                </span>
              </div>
            ) : (
              <div
                className={`TriviaEditViewListUI_leftContainer_singleQuestion`}
              >
                <div
                  className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey`}
                  style={{ backgroundColor: "#be0000cc" }}
                >
                  <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                    <PiCalendarPlus color="white" size={20} />
                  </span>
                </div>

                <div>
                  {currentTrivia.trivvyEndDate ? (
                    <span className="text-info">
                      {moment(currentTrivia.trivvyEndDate).format("MM/DD/YYYY")}
                    </span>
                  ) : (
                    <span
                      onClick={() => {
                        setShowEndDatEdit(true);
                      }}
                    >
                      <span style={{ fontSize: "12px", color: "#be0000cc" }}>
                        {" "}
                        Add end date
                      </span>
                    </span>
                  )}
                  {currentTrivia.trivvyEndDate ? (
                    <span className="ml-2">
                      <BiEdit
                        className="mr-1 text-warning"
                        onClick={() => setShowEndDatEdit(true)}
                        size={15}
                      />{" "}
                      <BiTrashAlt
                        className="text-danger"
                        onClick={() => {
                          setCurrentTrivia({
                            ...currentTrivia,
                            trivvyEndDate: null,
                          });
                          setShowEndDatEdit(false);

                          callApiToAutoSave("trivvyEndDate", null);
                        }}
                        size={15}
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}

            {showScheduledDateEdit ? (
              <div>
                <div className="d-flex align-items-center mt-2 trivvy-edit-end-date-container edit-scheduled-date">
                  <ReactDatePicker
                    dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                    id="actionDueDate"
                    placeholderText="Enter date: MM/DD/YYYY"
                    className="form-control filter-action-date-input"
                    minDate={new Date()}
                    minTime={
                      currentTrivia.scheduledDate &&
                      moment().isSame(
                        moment(currentTrivia.scheduledDate),
                        "day"
                      )
                        ? moment()
                        : moment().startOf("day")
                    }
                    maxTime={moment().endOf("day")}
                    selected={
                      typeof currentTrivia.scheduledDate == "string"
                        ? moment(currentTrivia.scheduledDate)
                        : currentTrivia.scheduledDate
                    }
                    onChange={(v) => {
                      if (v) {
                        const date = moment(v);
                        if (
                          moment()
                            .startOf("day")
                            .isSame(date, "hour")
                        ) {
                          // Today @ midnight selected: bump to the next full hour (TBV-624: 00 min, 00 sec)
                          scheduleDateUpdate(
                            moment()
                              .add(1, "hour")
                              .startOf("hour")
                          );
                        } else {
                          if (
                            moment(date)
                              .startOf("day")
                              .isSame(date, "hour")
                          ) {
                            // Future day @ midnight selected: default to 09:00:00
                            scheduleDateUpdate(date.add(9, "hours").startOf("hour"));
                          } else {
                            // Snap to the nearest quarter-hour (TBV: quarter-hour scheduling)
                            scheduleDateUpdate(snapToQuarterHour(date));
                          }
                        }
                      } else {
                        scheduleDateUpdate(null);
                      }
                    }}
                    showYearDropdown
                    showTimeSelect
                    timeFormat="h:mm a"
                    timeIntervals={15}
                    disabled={!isEditable || ["001", "002"].includes(planType)}
                  />

                  <span>
                    {" "}
                    Done{" "}
                    <BiCheckCircle
                      onClick={() => {
                        setShowScheduledDateEdit(false);
                      }}
                      className="ml-0 text-danger trivvy-edit-sidebar-end-date-success-icon"
                    ></BiCheckCircle>
                  </span>
                </div>

                {["001", "002"].includes(planType) ? (
                  <small className="text-danger">
                    Please upgrade your plan to premium
                  </small>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div
                className={`TriviaEditViewListUI_leftContainer_singleQuestion`}
              >
                <div
                  className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_grey`}
                  // style={{ backgroundColor: "#BCCF04" }}
                  style={{ backgroundColor: "#2074cceb" }}
                >
                  <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                    <BiAlarm color="white" size={20} />
                  </span>
                </div>

                <div>
                  {currentTrivia.scheduledDate ? (
                    <span className="text-info">
                      {moment(currentTrivia.scheduledDate).format(
                        "MMM DD, YYYY on hh:mm A"
                      )}
                    </span>
                  ) : (
                    <span
                      onClick={() => {
                        setShowScheduledDateEdit(true);
                      }}
                    >
                      <span style={{ fontSize: "12px", color: "#be0000cc" }}>
                        {" "}
                        Add scheduled date
                      </span>
                    </span>
                  )}
                  <br />
                  {currentTrivia.scheduledDate ? (
                    <span className="ml-2">
                      <BiEdit
                        className="mr-1 text-warning"
                        onClick={() => setShowScheduledDateEdit(true)}
                        size={15}
                      />{" "}
                      <BiTrashAlt
                        className="text-danger"
                        onClick={() => {
                          setShowEndDatEdit(false);
                          // Use scheduleDateUpdate so clearing also goes through the Advanced Settings endpoint (TBV-624)
                          scheduleDateUpdate(null);
                        }}
                        size={15}
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const middleUi = () => {
    const mainUI = (
      <React.Fragment>
        {currentQuestion == "WELCOME" ? (
          <div
            style={{
              display: view === "MOBILE" ? "flex" : "block",
              justifyContent: "center",
              width: view === "MOBILE" ? "" : "100%",
            }}
            className={`${view === "MOBILE" ? "" : "trivvy_box_shadow"}`}
          >
            {console.log("ffff", currentTrivia.welcomePage)}
            <SurveyWelcomeComponent
              welcomeData={
                currentTrivia.welcomePage || {
                  heading: "One thing before you go...",
                  buttonText: "Lets start",
                }
              }
              editWelcomeData={editWelcomeData}
              view={view}
              themeSettings={rightSidebarThemeSettings || THEME_SETTING}
              callApiToAutoSave={callApiToAutoSave}
              fileName={fileName}
              uploadUrl={currentTrivia.uploadUrl}
              quizName={currentTrivia.name}
              noOfQuestions={
                currentTrivia.questions && currentTrivia.questions.length
              }
              noOfMCQs={
                currentTrivia.questions &&
                currentTrivia.questions.filter((x) => x.question_type == "MCQ")
                  .length
              }
              isEditable={isEditable}
              totalQuizSeconds={totalQuizSeconds}
              linkedRewards={linkedRewards}
              quizEndDate={currentTrivia && currentTrivia.trivvyEndDate}
              timedQuestionsEnable={
                currentTrivia && currentTrivia.timedQuestionsEnable
              }
              isBannerOpen={isBannerOpen}
              setIsBannerOpen={setIsBannerOpen}
              uploadText={currentTrivia.uploadText}
              templateType={currentTrivia.templateType}
              customTemplateData={currentTrivia.customTemplateData}
              editTrivvyByKey={editTrivvyByKey}
              triviaData={currentTrivia}
              holidayTemplateName={holidayTemplateName}
              triviaId={currentTrivia._id}
              updateTriviaComments={updateTriviaComments}
              welcomeComments={currentTrivvyComments["WELCOME"]}
              isMixedTimedMcqTrivvy={isMixedTimedMcqTrivvy}
            />
          </div>
        ) : currentQuestion == "ENDING" ? (
          <div
            className={`${view === "MOBILE" ? "" : "trivvy_box_shadow"}`}
            style={{
              display: view === "MOBILE" ? "flex" : "block",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <SurveyEndingComponent
              endingData={
                currentTrivia.endingPage || {
                  heading: "Thanks for your time!",
                  subHeading: "We seriously appreciate your feedback.",
                }
              }
              editEndingData={editEndingData}
              view={view}
              themeSettings={rightSidebarThemeSettings}
              callApiToAutoSave={callApiToAutoSave}
              isEditable={isEditable}
              triviaId={currentTrivia._id}
              updateTriviaComments={updateTriviaComments}
              endingComments={currentTrivvyComments["ENDING"]}
            />
          </div>
        ) : currentQuestion == "RATING" ? (
          <div
            className={`${view === "MOBILE" ? "" : "trivvy_box_shadow"}`}
            style={{
              display: view === "MOBILE" ? "flex" : "block",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <TriviaRatingComponent
              view={view}
              themeSettings={rightSidebarThemeSettings || THEME_SETTING}
              callApiToAutoSave={callApiToAutoSave}
              isEditable={isEditable}
              ratingData={currentTrivia && currentTrivia.ratingPage}
              editRatingData={(data) => {
                setCurrentTrivia({ ...currentTrivia, ratingPage: data });
              }}
              triviaId={currentTrivia._id}
              updateTriviaComments={updateTriviaComments}
              ratingComments={currentTrivvyComments["RATING"]}
            />
          </div>
        ) : (
          currentQuestion && (
            <div
              className={`${view === "MOBILE" ? "" : "trivvy_box_shadow"}`}
              style={{
                display: view === "MOBILE" ? "flex" : "block",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <SurveyQuestionsComponent
                question={currentQuestion}
                editQuestion={editQuestion}
                view={isMobile ? "MOBILE" : view}
                themeSettings={rightSidebarThemeSettings || THEME_SETTING}
                callApiToAutoSave={callApiToAutoSave}
                generateOptionId={generateOptionId}
                editQuestionOptionsSync={editQuestionOptionsSync}
                isEditable={isEditable && questionEditable}
                regenerateQuestion={regenerateQuestion}
                isBannerOpen={isBannerOpen}
                setIsBannerOpen={setIsBannerOpen}
                triviaId={currentTrivia._id}
                updateTriviaComments={updateTriviaComments}
                questionComments={
                  currentQuestion
                    ? currentTrivvyComments[currentQuestion.question_id]
                    : []
                }
                trivvyFontsSettings={currentTrivia.trivvyFontsSettings}
                isAdmin={user.profile.role === "Admin"}
                userContentWarning={
                  user &&
                  user.profile &&
                  user.profile.organizationId &&
                  user.profile.organizationId.userContentWarning === true
                }
              />
            </div>
          )
        )}
      </React.Fragment>
    );
    return (
      <div id="trivvy_edit_page" className="d-block">
        <div
          style={{
            paddingBottom: "20px",
            width: "85%",
            margin: "auto",
            marginTop: "30px",
          }}
        >
          <div
            style={{
              ...applyCustomFontStyles(currentTrivia.trivvyFontsSettings),
            }}
          >
            {view == "MOBILE" ? (
              <div
                style={{
                  width: "420px",
                  height: "812px",
                  backgroundColor: "#000",
                  borderRadius: "20px",
                  position: "relative",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                  margin: "auto",
                  overflow: "hidden",
                  backgroundImage: `url(${iphoneImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="notch-iphone-wrapper">
                  <div className="notch-iphone"></div>
                </div>

                <div>{mainUI}</div>
              </div>
            ) : (
              mainUI
            )}
          </div>
        </div>
      </div>
    );
  };

  const disableAiAssistance = () => {};

  const rightUI = () => {
    return (
      <div
        style={{
          ...(isMobile && {
            fontSize: "10px",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
          }),
        }}
        className="scrollMobileNoScrollPc"
      >
        {rightSidebarThemeSettings && currentQuestion && (
          <div>
            {showStyleTheme ? (
              <div>
                <div className="my-3 cursor-pointer">
                  <b
                    onClick={() => {
                      setShowStyleTheme(!showStyleTheme);
                    }}
                    className="font-weight-bold"
                    style={{ fontSize: "15px" }}
                  >
                    {" "}
                    <TiChevronLeft
                      fontWeight="700"
                      className="font-weight-bold mr-3"
                    />{" "}
                    Style and theme{" "}
                  </b>
                </div>
                {rightSidebarThemeSettings && (
                  <div className="mb-3">
                    <FontSelector
                      disabled={!isEditable}
                      selectedFont={rightSidebarThemeSettings.fontFamilyName}
                      onChange={(data) => {
                        changeThemeSettings("fontFamilyName", data);
                      }}
                    />

                    <FontStyleSelector
                      disabled={!isEditable}
                      selectedFontStyle={rightSidebarThemeSettings.fontStyle}
                      onChange={(data) => {
                        changeThemeSettings("fontStyle", data);
                      }}
                    />
                  </div>
                )}

                <div
                  className={`survey_config_colors_background my-3 ${
                    isEditable ? "" : "opacity40"
                  }`}
                >
                  <Label className="mb-0">
                    {" "}
                    <b>
                      {currentQuestion === "WELCOME"
                        ? "Welcome"
                        : currentQuestion === "ENDING"
                        ? "Ending"
                        : "Question"}{" "}
                      Background
                    </b>
                  </Label>

                  <ColorPickerWrapper
                    color={
                      rightSidebarThemeSettings &&
                      rightSidebarThemeSettings.quizBackgroundColor
                        ? convertToRgba(
                            rightSidebarThemeSettings.quizBackgroundColor
                          )
                        : "#CFCDC9"
                    }
                    onChange={(e) =>
                      changeThemeSettings("quizBackgroundColor", e)
                    }
                    className="brandColor ml-3"
                    disabled={!isEditable}
                  />
                </div>

                <div
                  className={`my-3 survey_config_colors_background ${
                    isEditable ? "" : "opacity40"
                  }`}
                >
                  <Label className="mb-0">
                    {" "}
                    <b>
                      {" "}
                      {currentQuestion === "WELCOME"
                        ? "Welcome"
                        : currentQuestion === "ENDING"
                        ? "Ending"
                        : "Question"}{" "}
                      Text{" "}
                    </b>{" "}
                  </Label>

                  <ColorPickerWrapper
                    color={
                      rightSidebarThemeSettings &&
                      rightSidebarThemeSettings.quizTextColor
                        ? convertToRgba(rightSidebarThemeSettings.quizTextColor)
                        : "#CFCDC9"
                    }
                    onChange={(e) => changeThemeSettings("quizTextColor", e)}
                    className="brandColor ml-3"
                    disabled={!isEditable}
                  />
                </div>

                {currentQuestion === "WELCOME" && (
                  <div
                    className={`my-3 survey_config_colors_background ${
                      isEditable ? "" : "opacity40"
                    }`}
                  >
                    <Label className="mb-0">
                      {" "}
                      <b>Start Button Background </b>{" "}
                    </Label>
                    <ColorPickerWrapper
                      color={
                        currentTrivia &&
                        currentTrivia.welcomePage &&
                        currentTrivia.welcomePage.startButtonSettings &&
                        !["rgb(255, 255, 255)", "#FFFFFF", "#ffffff"].includes(
                          currentTrivia.welcomePage.startButtonSettings
                            .backgroundColor
                        )
                          ? convertToRgba(
                              currentTrivia.welcomePage.startButtonSettings
                                .backgroundColor
                            )
                          : null
                      }
                      onChange={(e) =>
                        changeStartButtonColor("backgroundColor", e)
                      }
                      className="brandColor ml-3"
                      disabled={!isEditable}
                    />
                  </div>
                )}

                {currentQuestion === "WELCOME" && (
                  <div
                    className={`my-3 survey_config_colors_background ${
                      isEditable ? "" : "opacity40"
                    }`}
                  >
                    <Label className="mb-0">
                      {" "}
                      <b>Start Button Text </b>{" "}
                    </Label>

                    <ColorPickerWrapper
                      color={
                        currentTrivia &&
                        currentTrivia.welcomePage &&
                        currentTrivia.welcomePage.startButtonSettings
                          ? convertToRgba(
                              currentTrivia.welcomePage.startButtonSettings
                                .color
                            )
                          : convertToRgba("rgb(255, 69, 0)")
                      }
                      onChange={(e) => changeStartButtonColor("color", e)}
                      className="brandColor ml-3"
                      disabled={!isEditable}
                    />
                  </div>
                )}

                {currentQuestion == "RATING" && (
                  <div
                    className={`my-3 survey_config_colors_background ${
                      isEditable ? "" : "opacity40"
                    }`}
                  >
                    <Label className="mb-0">Star color</Label>
                    <ColorPickerWrapper
                      color={
                        (currentTrivia &&
                          currentTrivia.ratingPage &&
                          currentTrivia.ratingPage.starColor) ||
                        "#F8D748"
                      }
                      onChange={(e) => editRatingData(e, "starColor")}
                      className="brandColor ml-3"
                      disabled={!isEditable}
                    />
                  </div>
                )}

                <div
                  className={`my-4 d-flex align-items-center ${
                    isEditable ? "" : "opacity40"
                  }`}
                  data-tip={
                    applyToAllPages
                      ? "Change colors & then apply to all pages again."
                      : "Apply this colors for all pages."
                  }
                >
                  <Label className="mb-0">
                    {" "}
                    <b>
                      {applyToAllPages ? "Applied" : "Apply"} to all pages
                    </b>{" "}
                  </Label>
                  <Toggle
                    className="brandColor float-right ml-3"
                    checked={applyToAllPages}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      if (checked) {
                        applyThemeSettingsToAllPages(rightSidebarThemeSettings);
                      }
                    }}
                    disabled={!isEditable ? true : applyToAllPages}
                  />
                </div>
              </div>
            ) : showQuestionDG &&
              currentQuestion &&
              currentQuestion.question_type === "MCQ" &&
              currentQuestion.question_id &&
              currentQuestion.is_ai_generated &&
              !currentTrivia.isBuiltInWithAiType ? (
              <div>
                <div className="my-3 cursor-pointer text-success">
                  <span
                    onClick={() => {
                      setShowQuestionDG(!showQuestionDG);
                    }}
                    className="font-weight-bold"
                    style={{ fontSize: "15px" }}
                  >
                    {" "}
                    <TiChevronLeft
                      fontWeight="700"
                      className="font-weight-bold mr-3"
                    />{" "}
                    Question Difficulty and Generation{" "}
                  </span>
                </div>
                {currentQuestion.question_id &&
                currentQuestion.question_type === "MCQ" &&
                currentQuestion.is_ai_generated ? (
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="trivia-action-button-purple my-2 w-100"
                      disabled={!(isEditable && questionEditable)}
                    >
                      {currentQuestion.difficultyLevel &&
                      DIFFICULTY_LEVELS.find(
                        (x) => x.value == currentQuestion.difficultyLevel
                      )
                        ? DIFFICULTY_LEVELS.find(
                            (x) => x.value == currentQuestion.difficultyLevel
                          ).label
                        : "Question Difficulty"}{" "}
                      <FaCaretDown />
                    </DropdownToggle>
                    <DropdownMenu>
                      {DIFFICULTY_LEVELS.map((x) => {
                        return (
                          <DropdownItem
                            onClick={() => {
                              regenerateQuestion(currentQuestion, x.value);
                            }}
                          >
                            {x.label}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : (
                  ""
                )}

                {isEditable &&
                questionEditable &&
                currentQuestion &&
                (currentQuestion.question_type == "MCQ" ||
                  (currentQuestion.question_type == "TEXT" &&
                    isTrivvyGeneratedFromCustomTemplates(currentTrivia))) &&
                currentQuestion.is_ai_generated ? (
                  <div className="my-3">
                    <Button
                      color="success"
                      onClick={() =>
                        regenerateQuestion(
                          currentQuestion,
                          currentQuestion.difficultyLevel
                        )
                      }
                      className="cursor-pointer w-100 font-styling-right-sidebar-items"
                      outline
                    >
                      <span>
                        Regenerate <FaRecycle className="mr-1" />
                      </span>
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div>
                {/* {currentQuestion && currentQuestion.question_id ? (
                  <div>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        className="trivia-action-button-main my-2 w-100"
                        disabled={
                          !(isEditable && questionEditable) ||
                          ["001", "002"].includes(planType)
                        }
                      >
                        {currentQuestion.aiAssistQuestions &&
                        currentQuestion.aiAssistQuestions.operationType
                          ? ASSIST_OPTIONS_MAP[
                              currentQuestion.aiAssistQuestions.operationType
                            ]
                          : "AI Assistance"}{" "}
                        <FaCaretDown />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => {
                            rephraseQuestionApi("MORE_CLEAR");
                          }}
                        >
                          {ASSIST_OPTIONS_MAP["MORE_CLEAR"]}
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            rephraseQuestionApi("MORE_ENGAGING");
                          }}
                        >
                          {ASSIST_OPTIONS_MAP["MORE_ENGAGING"]}
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            rephraseQuestionApi("MORE_SPECIFIC");
                          }}
                        >
                          {ASSIST_OPTIONS_MAP["MORE_SPECIFIC"]}
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    {["001", "002"].includes(planType) ? (
                      <small className="text-danger">
                        Please upgrade to premium for Ai Assistance
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )} */}
                {currentQuestion &&
                (currentQuestion.question_id ||
                  currentQuestion == "RATING") ? (
                  <div
                    className={`my-3 d-flex align-items-center ${
                      isEditable ? "" : "opacity40"
                    }`}
                  >
                    <b>Make this question required</b>
                    <Toggle
                      className="ml-3"
                      disabled={
                        currentQuestion == "RATING"
                          ? !isEditable
                          : !(isEditable && questionEditable)
                      }
                      checked={
                        currentQuestion == "RATING"
                          ? currentTrivia.ratingPage.isRequired
                          : currentQuestion.isRequired
                      }
                      onChange={(e) => {
                        if (currentQuestion == "RATING") {
                          editRatingData(e.target.checked, "isRequired");
                        } else {
                          editQuestion(
                            {
                              ...currentQuestion,
                              isRequired: e.target.checked,
                            },
                            "isRequired"
                          );
                        }
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}

                {/* {currentQuestion &&
                currentQuestion.question_id &&
                currentQuestion.is_ai_generated &&
                !currentTrivia.isBuiltInWithAiType ? (
                  <div className="my-3 cursor-pointer text-success">
                    <span
                      onClick={() => {
                        setShowQuestionDG(!showQuestionDG);
                      }}
                      style={{ fontSize: "15px" }}
                    >
                      Question Difficulty and <br /> Generation
                      <TiChevronRight className="font-weight-bold ml-2" />{" "}
                    </span>
                  </div>
                ) : (
                  ""
                )} */}

                {isEditable &&
                questionEditable &&
                currentQuestion &&
                (currentQuestion.question_id ||
                  currentQuestion === "WELCOME") ? (
                  <div className="mb-4 mt-4">
                    <span
                      onClick={() => openBannerModal()}
                      className="cursor-pointer font-styling-right-sidebar-items"
                    >
                      Add media/images <BiImage size={24} className="mr-1" />
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <div className="my-3 cursor-pointer">
                  <span
                    onClick={() => {
                      setShowStyleTheme(!showStyleTheme);
                    }}
                    // className="font-weight-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Style and theme{" "}
                    <TiChevronRight className="font-weight-bold ml-2" />{" "}
                  </span>
                </div>

                <ReactTooltip />

                {currentQuestion && currentQuestion.question_id  && (
                  <div className="mt-4">
                    {/* {!currentQuestion.is_ai_generated && ( */}
                    {!currentTrivia.isBuiltInWithAiType &&
                      currentQuestion.question_type == "MCQ" && (
                        <span
                          className="font-weight-bold trivvy-edit-rt-mc-container-title"
                          // style={{ fontSize: "15px" }}
                        >
                          Select correct option for this question
                        </span>
                      )}

                    {/* )} */}
                    {!currentTrivia.isBuiltInWithAiType &&
                      currentQuestion.question_id &&
                      currentQuestion.question_type == "MCQ" &&
                      currentQuestion.options.map((option) => {
                        let isChecked = false;
                        if (
                          currentQuestion.correct_options &&
                          currentQuestion.correct_options.length
                        ) {
                          const opt = currentQuestion.correct_options[0];

                          if (opt && opt.option_id === option.option_id) {
                            isChecked = true;
                          }
                        }

                        const editable = isEditable && questionEditable;

                        console.log({ editable });
                        return (
                          <Row className="mt-3 trivia-question-row-format">
                            <Col sm={2}>
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) =>
                                  handleSelectCorrect(option, !isChecked)
                                }
                                disabled={!editable}
                              />
                            </Col>
                            <Col sm={9}>
                              <span className="right-correct-opt-display-label">
                                {parse(option.text.replace("<br>", ""))}
                              </span>
                            </Col>
                          </Row>
                        );
                      })}

                    {currentTrivia.uploadUrl ? (
                      <a
                        href={currentTrivia.uploadUrl}
                        className="survey-config-rt-side-link-src"
                        target="_blank"
                      >
                        {" "}
                        <FiExternalLink size="18px" className="mr-1" /> View
                        link{" "}
                      </a>
                    ) : currentTrivia.uploadText ? (
                      <a
                        href={currentTrivia.uploadUrl}
                        onClick={() => {
                          setCustomTextModal(true);
                        }}
                        className="survey-config-rt-side-link-src"
                        target="_blank"
                      >
                        {" "}
                        <FiExternalLink size="18px" className="mr-1" /> View
                        text{" "}
                      </a>
                    ) : isTrivvyGeneratedFromCustomTemplates(currentTrivia) ? (
                      <a
                        href={currentTrivia.uploadUrl}
                        onClick={() => {
                          setTemplateParamsModal(getCustomTemplateDataHtml());
                        }}
                        className="survey-config-rt-side-link-src"
                        target="_blank"
                      >
                        {" "}
                        <FiExternalLink size="18px" className="mr-1" /> See
                        template Parameters{" "}
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                )}

                {templateParamsModal && (
                  <Modal isOpen={true}>
                    <ModalHeader
                      className="trivia_modal_header_bg"
                      toggle={() => setTemplateParamsModal(null)}
                    >
                      Custom Data
                    </ModalHeader>
                    <ModalBody className="p-3">{templateParamsModal}</ModalBody>
                  </Modal>
                )}

                <div className="trivvy-edit-rt-side-kc-source">
                  {currentQuestion &&
                  currentQuestion.source &&
                  currentQuestion.question_type == "MCQ" &&
                  getSourceStringfromQuestion(currentQuestion) ? (
                    <span>
                      <div>
                        <b>Source:</b>{" "}
                        <span>
                          {isEditable && questionEditable && (
                            <span>
                              {!currentQuestion.isSourceRemoved ? (
                                <span
                                  className="text-danger cursor-pointer float-right mr-4"
                                  onClick={() => {
                                    if (isEditable && questionEditable) {
                                      editQuestion(
                                        {
                                          ...currentQuestion,
                                          isSourceRemoved: true,
                                        },
                                        "isSourceRemoved"
                                      );
                                    }
                                  }}
                                >
                                  Remove <BiTrashAlt />
                                </span>
                              ) : (
                                <span
                                  onClick={() => {
                                    if (isEditable && questionEditable) {
                                      editQuestion(
                                        {
                                          ...currentQuestion,
                                          isSourceRemoved: false,
                                        },
                                        "isSourceRemoved"
                                      );
                                    }
                                  }}
                                  className="text-primary cursor-pointer float-right mr-4"
                                >
                                  Undo <FaUndo />{" "}
                                </span>
                              )}
                            </span>
                          )}
                        </span>
                      </div>
                      <div>
                        {!currentQuestion.isSourceRemoved
                          ? getSourceStringfromQuestion(currentQuestion)
                          : "No source"}
                      </div>
                      {/* <a href={currentTrivia.uploadUrl} target="_blank"> (view)</a> */}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="mt-5">
          <div className="mb-2 mt-2">
            <ButtonGroup size="sm">
              {!isMobile && (
                <Button
                  onClick={() => setView("DESKTOP")}
                  className={`px-4 py-2 trivia_view_switch ${
                    view === "DESKTOP" ? "active" : ""
                  }`}
                >
                  Desktop
                </Button>
              )}

              {!isMobile && (
                <Button
                  onClick={() => setView("MOBILE")}
                  className={`px-4 py-2 trivia_view_switch ${
                    view === "MOBILE" ? "active" : ""
                  }`}
                >
                  Mobile
                </Button>
              )}
            </ButtonGroup>
          </div>

          <div className="mt-5 trvvy-edit-rt-side-sugg-alert">
            <Alert color="info">
              <b>Suggestion:</b> {TRIVIA_EDIT_OVERTIME_TEXT}
            </Alert>
          </div>

          <div className="mt-4">
            {currentTrivia && currentTrivia.isPublished ? (
              <Alert color="success" className="text-center">
                You have published this Trivvy and can no longer edit it.
              </Alert>
            ) : !questionEditable ? (
              <Alert color="success" className="text-center">
                Users have already taken this Trivvy. You can no longer edit the
                questions.
              </Alert>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };

  if (isMobile && currentTrivia) {
    return (
      <div
        style={{
          height: "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        <div
          className="trivvy-edit-mobile-left-menu_btn"
          onClick={() => setMobileMenu("LEFT")}
          // data-tip={"Edit, Select, Reorder Questions & Welcome,Ending page,Due Date"}
        >
          <span>
            Menu <HiChevronDoubleRight size={25} ml-2 />{" "}
          </span>
        </div>
        <div
          className="trivvy-edit-mobile-right-menu_btn"
          onClick={() => setMobileMenu("RIGHT")}
          // data-tip={"Edit Selected Page/Questions settings colors, View Source."}
        >
          <span>
            {" "}
            <HiChevronDoubleLeft className="mr-2" size={25} />
            Settings{" "}
          </span>
        </div>

        {/* <ReactTooltip  /> */}

        <Drawer
          open={mobileMenu == "LEFT"}
          onClose={() => setMobileMenu(null)}
          direction="left"
          className="pt70px"
        >
          {leftUI()}
        </Drawer>
        <Drawer
          open={mobileMenu == "RIGHT"}
          onClose={() => setMobileMenu(null)}
          direction="right"
          className="pt70px"
        >
          {rightUI()}
        </Drawer>

        <div
          style={{
            marginTop: "70px",
          }}
        >
          {middleUi()}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        {currentTrivia && (
          <Row className="trivia_edit_ui_height_wrapper mx-0 px-0">
            <Col
              sm={2}
              className="TriviaEditViewListUI_leftContainer py-2 p-0 pl-2"
            >
              {leftUI()}
            </Col>

            <Col sm={8} className="px-3 center-main-trivia-ui">
              {middleUi()}
            </Col>
            <Col
              className="TriviaEditViewListUI_rightContainer pl-2 pr-4 py-2"
              sm={2}
            >
              {rightUI()}
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    currentTrivia: state.trivia.currentTrivia,
    questions:
      state.trivia.currentTrivia && state.trivia.currentTrivia.questions,
    currentTrivvyComments: state.trivia.currentTrivvyComments || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTriviaQuestions: (data) =>
      dispatch(actionCreators.editCurrentTriviaQuestions(data)),
    editCurrentTriviaWelcomeData: (data) =>
      dispatch(actionCreators.editCurrentTriviaWelcomeData(data)),
    editCurrentTriviaEndingData: (data) =>
      dispatch(actionCreators.editCurrentTriviaEndingData(data)),
    editCurrentTriviaThemeData: (data) =>
      dispatch(actionCreators.editCurrentTriviaThemeData(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    setCurrentTrivvyComments: (data) =>
      dispatch(actionCreators.setCurrentTrivvyComments(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaEditViewListUI, axios));
